// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { FacilityEventType } from "./Shared.FacilityEventType.gen";
import { TargetType } from "./Shared.TargetType.gen";
import { TargetStatus } from "./Shared.TargetStatus.gen";

export interface IEventClipInfo {
	status: string | undefined;

	notices: string | undefined;

	videoUrl: string | undefined;

	photoUrl: string | undefined;

	videoDataStart: string | undefined;

	videoDataEnd: string | undefined;

	eventType: FacilityEventType | undefined;

	movementLabel: string | undefined;

	facilityName: string | undefined;

	deviceName: string | undefined;

	dateCreated: string | undefined;

	targetType: TargetType | undefined;

	targetStatus: TargetStatus | undefined;

	maxVelocity: number | undefined;

	width: number | undefined;

	length: number | undefined;

	countAdjustment: number | undefined;

	$type?: string | undefined;
}
export class EventClipInfo {
	constructor(data?: IEventClipInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.videoDataStart) { this.videoDataStart = new Date(data.videoDataStart); }
		if (data.videoDataEnd) { this.videoDataEnd = new Date(data.videoDataEnd); }
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
	}

	status: string | undefined;

	notices: string | undefined;

	videoUrl: string | undefined;

	photoUrl: string | undefined;

	videoDataStart: Date | undefined;

	videoDataEnd: Date | undefined;

	eventType: FacilityEventType | undefined;

	movementLabel: string | undefined;

	facilityName: string | undefined;

	deviceName: string | undefined;

	dateCreated: Date | undefined;

	targetType: TargetType | undefined;

	targetStatus: TargetStatus | undefined;

	maxVelocity: number | undefined;

	width: number | undefined;

	length: number | undefined;

	countAdjustment: number | undefined;

	static $type: string = "CoreApi.Models.EventClipInfo, ";
	$type?: string | undefined = EventClipInfo.$type;
}

